import React from 'react';
import {noop, Text} from '@priority-software/priority-style-react';
import {texts} from '../../../../texts';
import {NumberDropdown} from './NumberDropdown';
import {TextDropdown} from './TextDropdown';
import {BPMStatusCondition as BPMStatusConditionValue} from '../utils';
import {DropdownItemData} from '@priority-software/priority-style-react/dist/components/DropdownV2/ChooseDropdown/ChooseDropdown';
import {AutomationChoose} from '../../../../../../reducer/model';
import {isRTL} from '../../../../../../../../Localization';

type Props = {
    type?: BPMStatusConditionValue;
    timeValue?: number;
    timeUnit?: number;
    timeField?: number;
    isActive?: boolean;
    timeUnits?: AutomationChoose[];
    dateFields?: AutomationChoose[];
    timeConditionOptions?: AutomationChoose[];
    timeCondition?: number;
    onChangeTimeValue?: (value: number) => void;
    onTimeStatusConditionChange?: (
        option: DropdownItemData,
        isSelected: boolean,
        name?: string
    ) => void;
    onDropdownChange?: (option: any, isSelected: boolean, name?: string) => void;
};

export const RadioContent = (props: Props) => {
    const {
        timeValue,
        timeUnit,
        timeField,
        type,
        isActive,
        timeUnits = [],
        dateFields = [],
        timeConditionOptions = [],
        timeCondition,
        onChangeTimeValue = noop,
        onTimeStatusConditionChange = noop,
        onDropdownChange = noop
    } = props;

    const isDisabled = !isActive;

    const timeFieldValue = isActive ? (timeField as number) : dateFields[0]?.value;
    const time = isActive ? (timeValue as number) : 0;
    const timeUnitValue = isActive ? (timeUnit as number) : timeUnits[0]?.value;
    const timeUnitText = timeUnits.find(unit => unit.value === timeUnitValue)?.label || '';

    if (type === BPMStatusConditionValue.TimeField) {
        return (
            <div>
                {texts.date_in_the} &nbsp;
                <TextDropdown
                    disabled={isDisabled}
                    value={timeFieldValue}
                    data={dateFields}
                    hasSearch={false}
                    onChange={onDropdownChange}
                    name="TimeField"
                />
                &nbsp;
                <TextDropdown
                    disabled={isDisabled}
                    hasSearch={false}
                    value={timeCondition}
                    data={timeConditionOptions}
                    onChange={onTimeStatusConditionChange}
                />
                &nbsp;
                <NumberDropdown
                    disabled={isDisabled}
                    value={time}
                    onChange={onChangeTimeValue}
                    unit={timeUnitText}
                />
                &nbsp;
                <TextDropdown
                    disabled={isDisabled}
                    hasSearch={false}
                    value={timeUnitValue}
                    data={timeUnits}
                    onChange={onDropdownChange}
                    name="TimeUnit"
                />
                &nbsp;
                {timeCondition > 0 && !isRTL() ? texts.ago_label : null}
            </div>
        );
    } else if (type === BPMStatusConditionValue.TimeValue) {
        return (
            <div>
                <span>{texts.doc_remains_status}</span> &nbsp;
                <NumberDropdown
                    value={time}
                    onChange={onChangeTimeValue}
                    unit={timeUnitText}
                />{' '}
                &nbsp;
                <TextDropdown
                    hasSearch={false}
                    value={timeUnitValue}
                    data={timeUnits}
                    onChange={onDropdownChange}
                    name="TimeUnit"
                />
            </div>
        );
    }
    return (
        <Text tag="span" skin="paragraph-2">
            {texts.doc_reaches_status}
        </Text>
    );
};
